module.exports = __webpack_public_path__ + "static/img/office2.8cde55c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/office/office2.png
// module id = zHnU
// module chunks = 1